import { ErrorResponse } from '../../global/adapters/crpAPI';

const showErrorMessage = (response: unknown) => {
  const error = (response as any)?.error ?? (response as any);
  const message = error?.message ?? 'An unexpected error occurred.';
  const publicReferenceId = error?.publicReferenceId;

  return publicReferenceId ? `Public Reference Id: ${publicReferenceId}\n${message}` : message;
};

export default showErrorMessage;
